// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React from "react";
import { InputField } from "./InputField";
import PrimaryButton from "./PrimaryButton";

const ChangeNameModal = () => {
  return (
    <>
      <p className="text-[#9392A2] text-sm font-medium leading-snug tracking-tight mt-1 mb-4">Enter your real name so everybody <br /> could recognise you.</p>
      <InputField label="Name" className="mb-8" />
      <PrimaryButton label="Confirm" className="py-2 w-full rounded-3xl" />
    </>
  );
};

export default ChangeNameModal;